import { curry } from 'lodash';

export const splitPercent = curry((percent: number, total: number) =>
  Math.floor(total * (percent / 100))
);
